import { render } from "./StaticCard.vue?vue&type=template&id=56b5c5c7&scoped=true"
import script from "./StaticCard.vue?vue&type=script&lang=js"
export * from "./StaticCard.vue?vue&type=script&lang=js"

import "./StaticCard.vue?vue&type=style&index=0&id=56b5c5c7&scoped=true&lang=css"

import exportComponent from "/Users/muftaua/Documents/dev/CCD-Stuff/web-ccd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b5c5c7"]])

export default __exports__